import { useEffect, useState } from "react";
import { ExternalMenuItem } from "../../../../../services/menu/models";
import { getExternalMenuItems } from "../../../../../services/menu";


const useSearchExternalItems = (menuId: number) => {

    const [query, setQuery] = useState("");
    const [externalIds, setExternalIds] = useState<string[]>([]);
    const [itemsByExternalId, setItemsByExternalId] = useState<{[s: string]: ExternalMenuItem}>({});
    const [isLoading, setIsLoading] = useState(false);
    const [items, setItems] = useState<ExternalMenuItem[]>([])

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const res = await getExternalMenuItems({
                externalIds, menuId, query
            });
            setItems(res.externalMenuItems);
            let t = {};
            res.externalMenuItems.forEach(item => {
                t[item.id] = item;
            });
            setItemsByExternalId(t);
            setIsLoading(false);
        })()
    }, [query, externalIds]);

    const getByExternalId = (externalId: string) => {
        return itemsByExternalId[externalId];
    }
    return {setQuery, setExternalIds, getByExternalId, isLoading, items};
}


export default useSearchExternalItems
